import SeranovaSandbox from "@/components/SeranovaSandbox.vue";

export default [
  {
    path: "/seranova-sandbox",
    name: "SeranovaSandbox",
    component: SeranovaSandbox
  }
];
